<template>
    <eg-modalv2
        height="auto"
        :width="modalSize"
        :show="showServiceModal"
        @close="$emit('close', false)"
        :paddingBody="false"
        :showFooter="false"
        :showHeader="false"
        :rounded="true"
        :scrollable="false"
    >
        <div slot="body" class="body-service">
            <div class="image-box">
                <div class="image">
                    <img src="@/assets/images/search-icon.svg" />
                </div>
            </div>
            <div class="form">
                <h2 class="title">
                    Selecione o <b>{{ textModal }}</b> desejado!
                </h2>
                <div class="input-box">
                    <multiselect
                        v-model="tag"
                        placeholder="Selecionar"
                        label="name"
                        track-by="id"
                        :preserve-search="true"
                        :options="tagList"
                        :options-limit="400"
                        :limit="10"
                        :allow-empty="true"
                        :searchable="true"
                        :multiple="false"
                        :hideSelected="true"
                        :select-label="select2Options.selectLabel"
                        :selected-label="select2Options.selectedLabel"
                        :group-values="tagServices"
                        :group-label="order"
                        :group-select="false"
                        :maxHeight="600"
                    >
                        <span slot="noResult">{{ select2Options.noResultsLabel }}</span>
                    </multiselect>
                    <transition name="slide-fade">
                        <p style="color: red" v-if="showErrorService">Campo obrigatório.</p>
                    </transition>
                </div>
                <div class="input-box" v-if="showState">
                    <multiselect
                        v-model="stateSelect"
                        placeholder="Selecionar"
                        label="label"
                        track-by="value"
                        :preserve-search="true"
                        :options="statesList"
                        :limit="10"
                        :allow-empty="true"
                        :searchable="true"
                        :multiple="false"
                        :hideSelected="true"
                        :select-label="select2Options.selectLabel"
                        :selected-label="select2Options.selectedLabel"
                    >
                        <span slot="noResult">{{ select2Options.noResultsLabel }}</span>
                    </multiselect>
                    <transition name="slide-fade">
                        <p style="color: red" v-if="showErrorState">Campo obrigatório.</p>
                    </transition>
                </div>
                <div class="action-box">
                    <eg-button variant="eg-yellow" block uppercase @click="searchSuppliers">
                        <font-awesome-icon :icon="['fas', 'search']" /> {{ buttonText }}
                    </eg-button>
                </div>
            </div>
        </div>
    </eg-modalv2>
</template>

<script>
export default {
    props: {
        showServiceModal: {
            type: Boolean,
            default: false
        },
        isMobile: Boolean,
        tagList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        tagServices: {
            type: String,
        },
        order: {
            type: String,
        },
        statesList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        showState: {
            type: Boolean,
            default: true
        },
        buttonText: {
            type: String,
            default: 'Buscar Fornecedores'
        },
        textModal: {
            type: String,
            default: 'serviço e o local'
        }
    },
    data() {
        return {
            tag: null,
            stateSelect: null,
            select2Options: {
                selectedLabel: 'Selecionado',
                selectLabel: 'Selecionar',
                noResultsLabel: 'Nenhum resultado encontrado.'
            },
            showErrorService: false,
            showErrorState: false
        };
    },
    methods: {
        async checkQueriesStrings() {
            const service = this.$route.query.servico;
            if (service && this.checkService(service)) {
                this.tag = this.getServiceByTagList(service);
            }
        },
        checkService(service) {
            return this.tagList[1].tagServices.some(({ name }) => name.toUpperCase() === service.toUpperCase());
        },
        getServiceByTagList(service) {
            return this.tagList[1].tagServices.find(({ name }) => name.toUpperCase() === service.toUpperCase());
        },
        searchSuppliers() {
            this.showErrorService = false;
            this.showErrorState = false;
            if (this.tag && this.stateSelect && this.showState) {
                this.$emit('searchSuppliers', { tag: this.tag, stateSelect: this.stateSelect });
            } else if (this.tag && !this.showState) {
                this.$emit('searchSuppliers', { tag: this.tag });
            } else {
                this.checkFieldErros();
            }
        },
        checkFieldErros() {
            if (!this.tag) this.showErrorService = true;
            if (!this.stateSelect) this.showErrorState = true;
        }
    },
    computed: {
        modalSize() {
            return this.isMobile ? '90%' : '675px';
        }
    },
    watch: {
        showServiceModal() {
            this.checkQueriesStrings();
        }
    }
};
</script>

<style lang="scss" scoped>
.body-service {
    display: flex;
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
    .image-box {
        width: 292px;
        background-color: rgba(242, 242, 242, 0.5);
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        @media screen and (max-width: 768px) {
            width: 100%;
            height: 170px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        .image {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
    }
    .form {
        margin: 40px;
        @media screen and (max-width: 768px) {
            margin: 32px 20px;
        }
        .title {
            display: inline-block;
            font-size: 22px;
            line-height: 30px;
            color: #0e3d74;
            margin: 0;
            margin-bottom: 24px;
        }
        .input-box {
            margin-bottom: 16px;
        }
    }
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
::v-deep .multiselect__content-wrapper {
    min-width: fit-content;
    box-shadow: 0px 3px 6px #00000029;
    overflow-y: visible;
}
</style>
